import CalendarSVG from '@/images/home/Calendar.svg?react'

const BOOK_A_CALL_URL = 'https://calendly.com/scoringfit'

const BASE = `
    inline-flex items-center justify-center flex-none
    whitespace-nowrap no-underline cursor-pointer
    transition-[transform,box-shadow] duration-150 ease-in-out motion-reduce:transition-none
    s-focus-ring
`

const VARIANTS = {
    // Desktop nav signature CTA (kit .nav-hero): the ONE hard shadow of the page
    // (guidelines, elevation 2). The label folds away below 1100px, icon stays.
    hero: `
        h-9 px-3.5 gap-2 text-[14px]
        bg-white text-(--t-strong)! hover:text-(--t-strong)!
        border border-(--t-strong) rounded-[10px]
        shadow-[4px_4px_0_var(--t-strong)]
        hover:translate-x-px hover:translate-y-px hover:shadow-[3px_3px_0_var(--t-strong)]
        max-[1100px]:px-2.5
    `,
    // Mobile side menu (kit .mmenu-btn): full-width ink button, 44px touch target.
    ink: `
        h-11 w-full px-3.5 gap-[9px] text-[14.5px]
        bg-(--btn-bg) text-white! hover:text-white!
        border-0 rounded-[10px]
    `,
}

export default function BookACallButton({ t, variant = 'hero', className = '' }) {
    return (
        <a
            href={BOOK_A_CALL_URL}
            target="_blank"
            rel="noreferrer"
            className={`${BASE} ${VARIANTS[variant] || VARIANTS.hero} ${className}`}
        >
            <CalendarSVG className="size-[15px] shrink-0" aria-hidden />
            <span className={variant === 'hero' ? 'max-[1100px]:hidden' : ''}>{t('Book a Call')}</span>
        </a>
    )
}
